// package.json
var version = "0.0.7";

// packages/core/helpers.ts
var pxPerSecond = (px, seconds) => px / seconds * 1e3;
var warn = (message) => {
  if (MarqueeConfig.disableWarnings) return;
  console.warn(`[@joycostudio/marquee]: ${message}`);
};

// packages/core/core.ts
var INITIALIZATION_WARNING = "Marquee not initialized!";
var NO_PROGRESS_WARNING = "There is no detected progress!";
var Marquee = class {
  /**
   * @param {HTMLElement} root - The container that will contain the marquee.
   * @param {Object} options - The options for the marquee.
   * @param {number} [options.speed=1] - The speed of the marquee in pixels per second.
   */
  constructor(root, { speed = 10 / 1, speedFactor = 1, direction = 1 } = {}) {
    this.speedFactor = 1;
    this.initialized = false;
    this.playing = false;
    this.root = root;
    this.speed = speed;
    this.speedFactor = speedFactor;
    this.direction = direction;
  }
  initialize(child) {
    if (this.initialized) {
      warn("Marquee already initialized!");
      return;
    }
    this.root.appendChild(child);
    this.clonedChild = child.cloneNode(true);
    this.root.appendChild(this.clonedChild);
    this.childWidth = child.offsetWidth;
    this.playing = true;
    this.start(this.direction);
    this.initialized = true;
  }
  play() {
    if (!this.childWidth) {
      warn("Marquee not initialized!");
      return;
    }
    if (this.animation) {
      this.animation.play();
      this.playing = true;
      return;
    }
  }
  start(direction, startProgress) {
    if (!this.childWidth) return;
    this.animation?.cancel();
    const duration = pxPerSecond(this.childWidth, this.speed);
    const keyframes = direction === 1 ? [{ transform: "translateX(0%)" }, { transform: "translateX(-50%)" }] : [{ transform: "translateX(-50%)" }, { transform: "translateX(0%)" }];
    this.animation = this.root.animate(keyframes, {
      duration,
      easing: "linear",
      iterations: Infinity
    });
    if (!this.playing) {
      this.animation.pause();
    } else {
      this.playing = true;
    }
    this.animation.playbackRate = this.speedFactor;
    if (startProgress !== undefined && this.animation.effect) {
      this.animation.currentTime = duration * startProgress;
    }
  }
  setDirection(direction) {
    if (direction === this.direction) return;
    this.setSpeedFactor(this.speedFactor * direction);
  }
  setSpeed(newSpeed) {
    if (!this.animation || !this.childWidth || !this.animation.effect) {
      warn(INITIALIZATION_WARNING);
      return;
    }
    if (this.speed === newSpeed) return;
    const timing = this.animation.effect.getComputedTiming();
    this.speed = newSpeed;
    this.start(this.direction, timing.progress ?? undefined);
  }
  setSpeedFactor(newSpeedFactor) {
    if (!this.animation || !this.animation.effect) {
      warn(INITIALIZATION_WARNING);
      return;
    }
    const speedWithDirection = this.speedFactor * this.direction;
    if (speedWithDirection === newSpeedFactor) return;
    const sign = Math.sign(newSpeedFactor);
    const hasChangedSign = sign !== Math.sign(speedWithDirection);
    if (!hasChangedSign) {
      this.direction = sign === 1 ? 1 : -1;
      this.speedFactor = Math.abs(newSpeedFactor);
      this.animation.playbackRate = this.speedFactor;
      return;
    }
    const timing = this.animation.effect.getComputedTiming();
    if (!timing.progress) {
      warn(NO_PROGRESS_WARNING);
      return;
    }
    const nextProgress = hasChangedSign ? 1 - timing.progress : timing.progress;
    this.direction = sign === 1 ? 1 : -1;
    this.speedFactor = Math.abs(newSpeedFactor);
    this.start(this.direction, nextProgress);
  }
  pause() {
    this.animation?.pause();
    this.playing = false;
  }
  destroy() {
    this.animation?.cancel();
    this.animation = undefined;
    if (this.clonedChild && this.clonedChild.parentNode === this.root) {
      this.root.removeChild(this.clonedChild);
    }
    this.clonedChild = undefined;
  }
};
var MarqueeConfig = {
  disableWarnings: false
};

// packages/core/index.ts
var VERSION = version;

export { Marquee, MarqueeConfig, VERSION };
//# sourceMappingURL=core.mjs.map
//# sourceMappingURL=core.mjs.map